import { registerQuery } from 'data-fetching-client';
import { fetchFormsByIds } from 'MeetingsLib/api/formsAPI';
export const formsByIdsQuery = registerQuery({
  args: ['guids'],
  fetcher: ({
    guids
  }) => fetchFormsByIds(guids),
  fieldName: 'formsByIds'
});